import { defaultWidgetOptions } from '../data/widgetDefaults'
import type { WidgetType } from '../data/widgetDefaults'

export const createWidgetDefaults = (type: WidgetType | undefined, theme: string) => ({
  ...defaultWidgetOptions(type ?? 'modal'),
  theme
})
